import { mapState } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import DiffsFileTree from '../../../diffs/components/diffs_file_tree.vue?vue3';
import { useDiffsList } from '../../stores/diffs_list.js?vue3';
import { useFileBrowser } from '../../../diffs/stores/file_browser.js?vue3';
import { useDiffsView } from '../../stores/diffs_view.js?vue3';
export default {
    name: 'FileBrowser',
    components: {
        DiffsFileTree
    },
    props: {
        groupBlobsListItems: {
            type: Boolean,
            required: false,
            default: true
        },
        linkedFilePath: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'click-file'
    ],
    computed: {
        ...mapState(useDiffsView, [
            'totalFilesCount',
            'singleFileMode',
            'currentDiffFileHash'
        ]),
        ...mapState(useDiffsList, [
            'loadedFiles'
        ]),
        ...mapState(useFileBrowser, [
            'fileBrowserVisible'
        ]),
        treeLoadedFiles () {
            return this.singleFileMode ? null : this.loadedFiles;
        }
    },
    methods: {
        clickFile (file) {
            this.$emit('click-file', file);
        },
        selectFile (file) {
            useDiffsView().setCurrentFile(file.fileHash);
        },
        toggleFolder (path) {
            useFileBrowser().toggleTreeOpen(path);
        }
    }
};
